








import Vue from "vue";
import planets from "../data/planets";
import { Component, Prop } from "vue-property-decorator";
import { Faction, factionPlanet, Planet as PlanetEnum } from "@gaia-project/engine";

@Component
export default class Planet extends Vue {
  @Prop()
  planet: PlanetEnum;

  @Prop()
  faction: Faction;

  @Prop()
  classes: string[];

  get radius() {
    return planets[this.planet].radius;
  }

  get fill() {
    // Comment for planet staying planets!
    if (this.faction) {
      return factionPlanet(this.faction);
    }
    return this.planet;
  }
}
